import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFirewall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFirewall"><Path d="M3 3H11.25V8H3V3Z" fill="currentColor"/><Path d="M8 9.5H16V14.5H8V9.5Z" fill="currentColor"/><Path d="M3 9.5H6.25V14.5H3V9.5Z" fill="currentColor"/><Path d="M17.7 9.5H20.95V14.5H17.7V9.5Z" fill="currentColor"/><Path d="M12.75 3H21V8H12.75V3Z" fill="currentColor"/><Path d="M3 16H11.25V21H3V16Z" fill="currentColor"/><Path d="M12.75 16H21V21H12.75V16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFirewall;
